/**
 * Bandeau « Mise en route à compléter » — Lot B.4.7 (onboarding interruptible).
 *
 * S'affiche en haut du dashboard quand le tenant actif est `actif` mais que
 * `onboarding_termine_le` est encore NULL (le user a fait `Reprendre plus
 * tard` au moins une fois sans terminer le wizard).
 *
 * Cliquer sur « Continuer la mise en route » repointe sur `/onboarding` —
 * le wizard reprend automatiquement à la 1ʳᵉ étape `pending` ou `rappel`.
 */

import { ArrowRight, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";

import { useMe } from "../../auth/use-me.js";

export function OnboardingBanner() {
  const { data } = useMe();
  if (!data) return null;

  const activeMembership =
    data.domaines_accessibles.find((m) => m.domaine.id === data.domaine_id_actif) ??
    data.domaines_accessibles[0];
  if (!activeMembership) return null;

  const { domaine } = activeMembership;
  // On ne montre le bandeau que si :
  //  - le domaine est validé par Max (`actif`) → sinon c'est `/compte-en-attente`
  //    qui prend le relais
  //  - et l'onboarding n'est pas encore finalisé.
  if (domaine.statut !== "actif" || domaine.onboarding_termine_le) return null;

  return (
    <div className="rounded-xl border border-rust-400 bg-gradient-to-r from-rust-100/70 to-champagne-100/50 p-5">
      <div className="flex flex-wrap items-center gap-4">
        <div className="rounded-lg bg-rust-200 p-2.5 text-rust-700">
          <Sparkles size={20} aria-hidden="true" className="animate-twinkle" />
        </div>
        <div className="flex-1">
          <p className="text-sm font-semibold text-rust-900">Mise en route à compléter</p>
          <p className="mt-0.5 text-xs text-rust-800">
            Quelques infos manquent pour activer pleinement votre espace (étiquettes, déclarations,
            parcellaire). Reprenez où vous vous étiez arrêté — votre saisie est sauvegardée.
          </p>
        </div>
        <Link
          to="/onboarding"
          className="ui-btn-primary inline-flex h-11 items-center gap-2 rounded-xl px-4 text-sm font-medium"
        >
          Continuer la mise en route
          <ArrowRight size={16} />
        </Link>
      </div>
    </div>
  );
}
